// extracted by css-extract-rspack-plugin
export default {"triggerButton":"YerhLLoPvEwTjdtn__triggerButton___"};